module.exports = __webpack_public_path__ + "assets/Underbite selected.30bd09e57a523676fcefe2b599050090.png";